// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__21Fmm","content":"styles_content__1PP1q","checkbox":"styles_checkbox__f3TyM","checkboxLabel":"styles_checkboxLabel__1g4tU"};